import {useQuery} from 'react-query'
import {ContentEditModalForm} from './ContentEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getContentById} from '../core/_requests'

const ContentEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: content,
    error,
  } = useQuery(
    `${QUERIES.CONTENTS_LIST}-content-${itemIdForUpdate}`,
    () => {
      return getContentById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <ContentEditModalForm isContentLoading={isLoading} content={{id: undefined}} />
  }

  if (!isLoading && !error && content) {
    return <ContentEditModalForm isContentLoading={isLoading} content={content} />
  }

  return null
}

export {ContentEditModalFormWrapper}
